<div class="app-full-height">
  <div fxLayout="column" fxLayoutGap="12px" class="m-4" [formGroup]="form">
    <h1 fxFlex="auto">Edit User</h1>

    <mat-tab-group
      fxLayout="column"
      fxLayoutAlign="stretch stretch"
      fxFlexFill
      dynamicHeight
    >
      <mat-tab label="User Details" fxLayout="column" fxLayoutGap="12px">
        <div fxLayout="column" fxLayoutGap="12px" class="pt-4">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" placeholder="Name" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="Email" />
            @if (form.get('email').hasError('conflict')) {
              <mat-error>{{ form.get('email').errors['conflict'] }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Username</mat-label>
            <input
              matInput
              formControlName="user_name"
              placeholder="Username"
            />
          </mat-form-field>
        </div>
        <div
          class="buttons"
          fxLayout="row"
          fxLayoutAlign="end center"
          fxLayoutGap="4px"
        >
          <button mat-flat-button (click)="backToList()" type="button">
            Cancel
          </button>
          <button
            mat-flat-button
            [disabled]="form.valid === false"
            color="primary"
            (click)="save(false)"
          >
            Save User Details
          </button>
        </div>
      </mat-tab>
      <mat-tab label="Reset Password" fxLayout="column" fxLayoutGap="12px">
        <div fxLayout="column" fxLayoutGap="12px" class="pt-4">
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input
              matInput
              formControlName="password"
              name="password"
              type="password"
              placeholder="Password"
            />
            @if (form.get('password').hasError('required')) {
              <mat-error>Password is required</mat-error>
            }
            @if (form.get('password').hasError('mismatch')) {
              <mat-error>Passwords do not match</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Retype Password</mat-label>
            <input
              matInput
              formControlName="password_confirmed"
              name="passwordConfirmed"
              type="password"
              placeholder="Password Confirmed"
            />

            @if (form.get('password').hasError('mismatch')) {
              <mat-error>Passwords do not match</mat-error>
            }
          </mat-form-field>
        </div>
        <div
          class="buttons"
          fxLayout="row"
          fxLayoutAlign="end center"
          fxLayoutGap="4px"
        >
          <button mat-flat-button (click)="backToList()" type="button">
            Cancel
          </button>
          <button
            mat-flat-button
            [disabled]="!form.valid"
            color="primary"
            (click)="save(true)"
          >
            Save Password
          </button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
